import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  caseChecklistDocumentsVerificationAPI,
  getChecklistByCaseTypeIDAPI,
  bulkChecklistExcelAPI
} from "../../../api/caseChecklistTab_api";

export const caseChecklistVerificationAction = createAsyncThunk(
  "checklist/caseChecklistVerification",
  async (caseID, { rejectWithValue }) => {
    const response = await caseChecklistDocumentsVerificationAPI(caseID);

    if (!response.success) {
      return rejectWithValue(response.error);
    }

    return response.data;
  },
);

export const getChecklistByCaseTypeIDAction = createAsyncThunk(
  "checklist/getChecklistByCaseTypeIDAction",
  async (caseTypeID, { rejectWithValue }) => {
    try {
      const response = await getChecklistByCaseTypeIDAPI(caseTypeID);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const bulkChecklistExcelAction = createAsyncThunk(
  "checklist/bulkChecklistExcel",
  async (values, { rejectWithValue }) => {
    try {
      const response = await bulkChecklistExcelAPI(values);

      const blob = response.data;
      const contentType = response.headers?.["content-type"] || "";

      // If backend sent JSON error with status 200
      if (contentType.includes("application/json")) {
        const text = await blob.text();
        const json = JSON.parse(text);

        return rejectWithValue(
          json?.error || json?.message || "Something went wrong"
        );
      }

      // Success → Excel blob
      return blob;

    } catch (error) {

      console.log("error", error, error.response);
      try {
        // Axios error response
        if (error.response?.data) {
          const data = error.response.data;

          // Blob error response
          if (data instanceof Blob) {
            const text = await data.text();
            const json = JSON.parse(text);

            return rejectWithValue(
              json?.error || json?.message || "Server error"
            );
          }

          // Normal JSON response
          return rejectWithValue(
            data?.error || data?.message || "Server error"
          );
        }

        return rejectWithValue(error.message || "Request failed");

      } catch (parseError) {
        return rejectWithValue("Unable to read server error");
      }
    }
  }
);